import { c as _c } from "react/compiler-runtime";
import Grid from '@mui/material/Grid';
import { useReviewContext } from '../../Context';
import AuthorNamesAndDate from './components/AuthorNamesAndDate';
import EditorAndReviewer from './components/EditorAndReviewer';
import Pictures from './components/Pictures';
export default function AuthorsAndEditors(t0) {
  const $ = _c(13);
  const {
    formattedDate
  } = t0;
  const {
    assigningEditor,
    authors,
    reviewedBy: t1
  } = useReviewContext();
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const reviewedBy = t2;
  if (authors.length === 0) {
    return null;
  }
  const firstReviewer = reviewedBy[0];
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: 2,
      md: 3
    };
    t4 = {
      letterSpacing: ".03rem"
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Grid display="flex" alignItems={{
      xs: "flex-start",
      md: "center"
    }}><Pictures /></Grid>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== formattedDate) {
    t6 = <Grid><AuthorNamesAndDate formattedDate={formattedDate} /></Grid>;
    $[5] = formattedDate;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== assigningEditor || $[8] !== firstReviewer) {
    t7 = (assigningEditor || firstReviewer) && <Grid><Grid container={true}>{assigningEditor && <Grid display="flex" alignItems="center" flexWrap="wrap" size={12}><EditorAndReviewer editorOrReviewer={assigningEditor} /></Grid>}{firstReviewer && <Grid display="flex" alignItems="center" flexWrap="wrap" size={12}><EditorAndReviewer editorOrReviewer={firstReviewer} isReview={true} /></Grid>}</Grid></Grid>;
    $[7] = assigningEditor;
    $[8] = firstReviewer;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <Grid marginTop={3} marginBottom={2} size={12}><Grid container={true} columnGap={t3} sx={t4}>{t5}<Grid flex={1}><Grid container={true} justifyContent="space-between">{t6}{t7}</Grid></Grid></Grid></Grid>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}